import React from 'react';
import { Modal, Form, Input } from 'antd';
import { useService } from '../service.hook';
import { ServiceRequest } from '../../../request/service.request';
import { validateLevel, validateLevelName } from '../../../validator/level.validator';
import { TextEditorView } from '../../../view/text-editor.view';
import FileUploadView from '../../../view/file-upload.view';

export const AddServiceComponent: React.FC<{ open: boolean, onCancel: () => void }> = ({ open, onCancel }) => {
    const [form] = Form.useForm();
    const { loading, updateLoading, saveService } = useService()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const serviceRequest = {
                name: values["name"],
                order: Number(values["order"]),
                description: values["description"],
                thumbnail: values["thumbnail"]
            } as ServiceRequest
            saveService(serviceRequest, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
        form.resetFields()
        onCancel();
    }

    const onFailure = () => {
        updateLoading(false);
    }

    return (
        <Modal
            open={open}
            title="Add New Service"
            onCancel={onCancel}
            confirmLoading={loading}
            onOk={handleOk}
            okText={"Submit"}
            cancelText={"Cancel"}
            style={{ top: 8, maxWidth: 768 }}
            width={'90vw'}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, validator: validateLevelName }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="order"
                    label="Order"
                    rules={[{ required: true, validator: validateLevel }]}
                >
                    <Input placeholder="Enter order" />
                </Form.Item>

                <Form.Item
                    name="description"
                    label="Description"
                    rules={[{ required: true, message: 'Please enter description' }]}
                >
                    <TextEditorView placeholder={'Please enter description'}
                        classes="editor-custom-view"
                        onChange={() => { }}
                        readOnly={false} />
                </Form.Item>

                <Form.Item
                    name="thumbnail"
                    label="Thumbnail"
                    rules={[{ required: true, message: 'Please add thumbnail' }]}
                >
                    <FileUploadView onChange={() => { }} />
                </Form.Item>
            </Form>
        </Modal>
    );
}